import { getQuantityOfProductInCart } from 'bento-ordering/cart/selectors';

export const formatCateringLocationInventory = (
  locationInventory,
  menuList,
  cart
) => {
  const formattedMenuList = menuList.map(menuItem => {
    const itemInventory = locationInventory?.items.find(
      item => item.product_id === menuItem.product.id
    );
    const qtyOfProductInCart = getQuantityOfProductInCart(
      cart,
      menuItem.product.id
    );

    if (itemInventory) {
      menuItem = {
        ...menuItem,
        inventory: itemInventory.inventory_remaining,
        lowInventoryCount: itemInventory.low_inventory_count,
        inventoryLessCart:
          itemInventory.inventory_remaining === null
            ? null
            : itemInventory.inventory_remaining - qtyOfProductInCart
      };
    } else {
      menuItem = {
        ...menuItem,
        inventory: null,
        lowInventoryCount: null,
        inventoryLessCart: null
      };
    }
    return menuItem;
  });
  return formattedMenuList;
};
